import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import {
  EditOutlined,
  DragOutlined,
  MoreOutlined,
  FileImageOutlined,
} from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'

function ScanItem(props) {
  const { el, setVisible, setActiveItem } = props
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: el.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  // Handle data which might be a string or object
  const getImageSrc = () => {
    if (!el.data) return ''
    if (typeof el.data === 'string') {
      try {
        const parsed = JSON.parse(el.data)
        return parsed?.thumbnail || ''
      } catch {
        return ''
      }
    }
    return el.data?.thumbnail || ''
  }

  const imageSrc = getImageSrc()

  // Get display name from data.name
  const getDisplayName = () => {
    if (el.data) {
      if (typeof el.data === 'string') {
        try {
          const parsed = JSON.parse(el.data)
          return parsed?.name || ''
        } catch {
          return ''
        }
      }
      return el.data?.name || ''
    }
    return ''
  }

  const displayName = getDisplayName()

  // Get scan URL from data.src
  const getScanUrl = () => {
    if (el.data) {
      if (typeof el.data === 'string') {
        try {
          const parsed = JSON.parse(el.data)
          return parsed?.src || ''
        } catch {
          return ''
        }
      }
      return el.data?.src || ''
    }
    return ''
  }

  const handleEdit = () => {
    setActiveItem(el)
    setVisible(true)
  }

  const handleViewScan = () => {
    const scanUrl = getScanUrl()
    if (scanUrl) {
      window.open(scanUrl, '_blank')
    }
  }

  const handleAddBefore = () => {
    setActiveItem({
      actionType: 'add',
      mediaType: 'scan',
      xExperienceId: el.xExperienceId,
      insertPosition: 'before',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const handleAddAfter = () => {
    setActiveItem({
      actionType: 'add',
      mediaType: 'scan',
      xExperienceId: el.xExperienceId,
      insertPosition: 'after',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const menu = (
    <Menu>
      <Menu.Item key="addBefore" onClick={handleAddBefore}>
        Add Scan Before
      </Menu.Item>
      <Menu.Item key="addAfter" onClick={handleAddAfter}>
        Add Scan After
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="viewScan" onClick={handleViewScan}>
        View Scan
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        data-id={el.id}
        className="inventory-row"
      >
        <div className="inventory-row-drag-handle" {...listeners}>
          <DragOutlined />
        </div>
        <div className="inventory-row-thumbnail">
          {imageSrc ? (
            <img alt={displayName} src={imageSrc} />
          ) : (
            <div className="thumbnail-placeholder">
              <FileImageOutlined
                style={{ fontSize: '24px', color: '#bfbfbf' }}
              />
            </div>
          )}
        </div>
        <div className="inventory-row-content">
          <div className="inventory-row-display-name">{displayName}</div>
        </div>
        <div className="inventory-row-actions">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={handleEdit}
            className="inventory-row-edit-btn"
          />
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="text"
              icon={<MoreOutlined />}
              className="inventory-row-more-btn"
            />
          </Dropdown>
        </div>
      </div>
    </>
  )
}
export default ScanItem
